import { HttpParams } from "@angular/common/http";
import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as moment from "moment";
import { WorkOrder, WorkOrderStatus } from "../../model";
import { StatisticService } from "../../service/statistic.service";


@Component({
    selector: 'work-order-edit-dialog',
    template: require('./work-order-edit-dialog.component.html')
})
export class WorkOrderEditDialogComponent {

    @ViewChild('form') form: NgForm;

    workOrder: WorkOrder;
    statusOnly: boolean;
    statuses: string[] = Object.values(WorkOrderStatus);
    startMoment: moment.Moment;
    endMoment: moment.Moment;
    canComplete: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<WorkOrderEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        @Inject(forwardRef(() => StatisticService)) private statisticService: StatisticService
    ) {
        this.statusOnly = data.statusOnly;
        this.workOrder = data.workOrder;
        if (this.workOrder.startTimestamp) {
            this.startMoment = moment(this.workOrder.startTimestamp);
        }
        if (this.workOrder.endTimestamp) {
            this.endMoment = moment(this.workOrder.endTimestamp);
        }
        this.checkCanComplete();
    }

    private checkCanComplete(): void {
        let params = new HttpParams();
        params = params.set('resource', 'action');
        params = params.set('aggregation', 'COUNT');
        params = params.set('thingId', this.workOrder.thingId);
        params = params.set('workOrderId', `eq;${this.workOrder.id}`);
        params = params.set('executionState', 'exists;false');
        this.statisticService.getStatisticPromise(null, params).then(results => {
            const count = results[0];
            this.canComplete = !count?.value;
        });
    }

    save(): void {
        const formValue = this.form.form.getRawValue();
        let body;
        if (this.statusOnly) {
            body = Object.assign({}, this.workOrder, { status: formValue.status });
        } else {
            body = formValue;
            if (body.startMoment) {
                body.startTimestamp = body.startMoment.valueOf();
                delete body.startMoment
            }
            if (body.endMoment) {
                body.endTimestamp = body.endMoment.valueOf();
                delete body.endMoment
            }
        }
        this.dialogRef.close(body);
    }

}